class BreadscrumbsCtrl {
    constructor($state) {
        this.$state = $state;
    }

    go(breadcrumb) {
        this.$state.go(breadcrumb.state, breadcrumb.params, { reload: true });
    }
}

BreadscrumbsCtrl.$inject = ['$state'];

export default BreadscrumbsCtrl;